import { useState } from "react";
import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function EntityResolutionCard({ offer, language, disabled, stale, onConfirm }) {
  const { t, i18n } = useTranslation();
  const lng = language === "ar" || language === "en" ? language : i18n.resolvedLanguage;
  const text = (key) => t(`assistant.identity.${key}`, { lng });
  const [selections, setSelections] = useState(() => Object.fromEntries(
    offer.fields.filter((field) => field.candidates.length === 1)
      .map((field) => [field.path, field.candidates[0].publicId]),
  ));
  const complete = offer.fields.every((field) => field.candidates.some((candidate) => candidate.publicId === selections[field.path]));

  return (
    <Box component="section" aria-label={text("title")} lang={lng} dir={lng === "ar" ? "rtl" : "ltr"}
      sx={{ mt: 1.4, p: 1.4, borderRadius: 2.5, bgcolor: "#fff", border: "1px solid #cbd5e1" }}>
      <Typography fontWeight={800} variant="body2">{text("title")}</Typography>
      <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>{text("help")}</Typography>
      <Stack spacing={1.4} sx={{ mt: 1.4 }}>
        {offer.fields.map((field) => (
          <Box key={field.path} role="group" aria-label={text(field.type)}>
            <Typography variant="caption" fontWeight={800} display="block" sx={{ mb: 0.6 }}>{text(field.type)}</Typography>
            <Stack direction="row" gap={0.7} flexWrap="wrap">
              {field.candidates.map((candidate) => (
                <Button key={candidate.publicId} size="small" variant={selections[field.path] === candidate.publicId ? "contained" : "outlined"}
                  aria-pressed={selections[field.path] === candidate.publicId} disabled={disabled || stale}
                  onClick={() => setSelections((current) => ({ ...current, [field.path]: candidate.publicId }))}
                  sx={{ textTransform: "none", maxWidth: "100%", overflowWrap: "anywhere" }}>
                  {candidate.label}
                </Button>
              ))}
              {!field.candidates.length && <Typography variant="body2" color="text.secondary">{text("noCandidates")}</Typography>}
            </Stack>
          </Box>
        ))}
      </Stack>
      {stale ? <Alert severity="info" sx={{ mt: 1.3 }}>{text("stale")}</Alert> : (
        <Button size="small" variant="contained" disabled={disabled || !complete} onClick={() => onConfirm(selections)}
          sx={{ mt: 1.5, textTransform: "none", fontWeight: 800 }}>
          {text("confirm")}
        </Button>
      )}
    </Box>
  );
}
